import type {
  PhoneVerifyRequestResultApi,
  PhoneVerifySubmitResultApi,
} from 'api-typings/users/users';
import type {
  PhoneVerifyRequestResult,
  PhoneVerifySubmitResult,
} from './phone-verification.model';

export function transformVerificationRequest(
  data: PhoneVerifyRequestResultApi,
): PhoneVerifyRequestResult {
  return {
    referenceId: data.reference_id,
  };
}

export function transformVerificationConfirmation(
  data: PhoneVerifySubmitResultApi,
): PhoneVerifySubmitResult {
  return {
    idVerificationRequired: data.id_verification_required ?? false,
  };
}
